import { render, staticRenderFns } from "./ContractorRatingNew.vue?vue&type=template&id=5242f44c&scoped=true"
import script from "./ContractorRatingNew.vue?vue&type=script&lang=ts"
export * from "./ContractorRatingNew.vue?vue&type=script&lang=ts"
import style0 from "./ContractorRatingNew.vue?vue&type=style&index=0&id=5242f44c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5242f44c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5242f44c')) {
      api.createRecord('5242f44c', component.options)
    } else {
      api.reload('5242f44c', component.options)
    }
    module.hot.accept("./ContractorRatingNew.vue?vue&type=template&id=5242f44c&scoped=true", function () {
      api.rerender('5242f44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rating/ContractorRatingNew.vue"
export default component.exports